import enviro from 'enviro';
// @ts-expect-error dependency missing types
import FeedbackLoader from 'feedback-loader';
import { jsx as _jsx } from "react/jsx-runtime";
export const Surveys = {
  MVP_BETA: 'MVP_BETA',
  CTA_MIGRATION: 'CTA_MIGRATION'
};
const SurveyOptions = {
  [Surveys.MVP_BETA]: {
    id: enviro.isQa() ? null : 912,
    delay: 3000
  },
  [Surveys.CTA_MIGRATION]: {
    id: enviro.isQa() ? null : 1026,
    delay: 3000
  }
};
const debugLog = (...message) => {
  if (enviro.debug('CSAT_SURVEY')) {
    console.log(...message);
  }
};
export const renderFeedbackLoader = survey => {
  const activeSurvey = SurveyOptions[survey] || {};
  const {
    id,
    delay
  } = activeSurvey;
  if (!id) {
    debugLog(`No id for ${survey}`);
    return null;
  }
  const delayMs = delay || 3000;
  const handleFeedbackClientLoad = feedbackClient => {
    if (id) {
      debugLog(`Feedback client loaded, triggering ${survey}`);
      feedbackClient.loadSurvey('CSAT', id);
    } else {
      debugLog('Feedback client loaded');
    }
  };
  return /*#__PURE__*/_jsx(FeedbackLoader, {
    clientLoadOnly: false,
    delayMs: delayMs,
    onClientLoad: handleFeedbackClientLoad
  });
};